import React from "react";
import {css, Theme} from "@emotion/react";

import {Badge} from "@pg-design/badge-module";
import {position} from "@pg-design/helpers-css";
import {Picture} from "@pg-design/picture-module";

interface IProps {
    article: {
        gallery: (
            | {
                  image: {
                      g_img_440x440: string;
                      g_img_728x400: string;
                      g_img_1160x638: string;
                  } | null;
              }
            | undefined
        )[];
        is_sponsored: boolean;
        title: string;
    };
}

export const ArticleMainImage: React.FunctionComponent<IProps> = (props) => {
    const {
        article: {title, gallery}
    } = props;
    return (
        <div css={position("relative")}>
            {props.article.is_sponsored ? (
                <Badge variant="label_highlight" css={badge}>
                    artykuł sponsorowany
                </Badge>
            ) : null}
            <Picture
                css={picture}
                sources={[
                    {minWidthPX: 0, width: 440, height: 440, src: gallery[0]?.image?.g_img_440x440},
                    {minWidthPX: 480, width: 728, height: 400, src: gallery[0]?.image?.g_img_728x400},
                    {minWidthPX: 768, width: 1160, height: 638, src: gallery[0]?.image?.g_img_1160x638}
                ]}
                alt={title}
                fetchPriority="high"
            />
        </div>
    );
};

const badge = (theme: Theme) => css`
    position: absolute;
    top: 2.4rem;
    left: 2.4rem;
    z-index: 2;
    background-color: ${theme.colors.primary};
`;

const picture = css`
    & img {
        width: 100%;:
    }
`;
